<template>
  <v-switch
    v-model="internalValue"
    class="pt-0 mt-0"
    dense
    inset
    hide-details
    :label="$t(`${labelTranslationPrefix}${translationValue}`)"
    :true-value="trueValue"
    :false-value="falseValue"
    :disabled="disabled"
  ></v-switch>
</template>

<script>
export default {
  name: 'BasketDeliverySwitch',
  props: {
    trueValue: {
      type: [String, Boolean],
      default: true,
    },
    falseValue: {
      type: [String, Boolean],
      default: false,
    },
    value: {
      type: [String, Boolean],
      default: undefined,
    },
    // label: {
    //   type: String,
    //   default: undefined,
    // },
    disabled: {
      type: Boolean,
      default: false,
    },
    labelTranslationPrefix: {
      type: String,
      default: 'checkout.delivery.types.',
    },
  },
  data() {
    return {
      translationValue: this.value,
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('change', newValue)
        this.translationValue = newValue
      },
    },
  },
}
</script>

<style></style>
